// Theory Categories web component

if (!customElements.get("td-tabs")) {
    class CategoriesComponent extends HTMLElement {
        constructor() {
            super();
        }
    
        connectedCallback() {
            this.setupEventListeners();
        }
    
        setupEventListeners() {
            let categoryButtons = this.querySelectorAll('.td-collections-header__selector');
            let showAllButton = this.querySelector(`.td-collections-header__show-all`);
        
            categoryButtons.forEach((categoryButton) => {
                categoryButton.addEventListener("click", () => {
                    let categoryId = categoryButton.dataset.category;
                    let buttonId = categoryButton.dataset.button;
                
                    let categories = this.querySelectorAll(`.td-collections-header__category`);
                    let buttons = this.querySelectorAll(`.td-collections-header__selector`);
                
                    // Loop through the gallery elements
                    categories.forEach(category => {
                        if (category.id === categoryId) {
                            category.classList.add('active');
                        } else {
                            category.classList.remove('active');
                        }
                    });
                
                    // Loop through the button elements
                    buttons.forEach(button => {
                        if (button.id === buttonId) {
                            button.classList.add('active');
                        } else {
                            button.classList.remove('active');
                        }
                    });
                
                    showAllButton.classList.remove('active');
                });
            });
        
            showAllButton.addEventListener("click", () => {
                let categories = this.querySelectorAll(`.td-collections-header__category`);
                let buttons = this.querySelectorAll(`.td-collections-header__selector`);
            
                categories.forEach(category => {
                    category.classList.add('active')
                });
            
                buttons.forEach(button => {
                    button.classList.remove('active')
                });
            
                showAllButton.classList.add('active');
            });
        }
    }
    
    // Register the custom element
    customElements.define('td-categories', CategoriesComponent);
}